import { Inject, Injectable } from '@angular/core';
import { forkJoin, Subject } from 'rxjs';
import { CatalogsService } from './catalogs.service';
import { InsurancesDic } from '../components/configuration-panel/interfaces/aseguradoras';
import { StepService } from '../pages/buro/services/step.service';
import { DataService } from './data.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalAlertComponent } from '../components/modal-alert/modal-alert.component';
import { Icons } from '../components/modal-alert/enums';
import { IProductDetail } from '../components/configuration-panel/interfaces/product';
import { DialogVideoComponent } from '../pages/cotiza/cotiza-components/dialog-video/dialog-video.component';
import { WINDOW } from '../utils/window';
import { InsuranceTypeIDsEnum } from '../utils/utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SummaryService {
  isChanged = false;
  templateSuffix = environment.templateSuffix;


  summary = {
    carTitle: '---',
    carModel: '---',
    carImage: './assets/img/auto_no_disponible.svg',
    state: '---',
    priceWithIva: '0',
    refund: '0',
    concept: '---',
    period: '---',
    initialPayment: '0',
    monthlyPayment: '0',
    insurance: '---',
    deadlineSelect: {},
    dataQuoter: {},
    stateSelected: {},
    registrationState: '',
    car: {
      brand: '---',
      subBrand: '---',
      version: '---',
      year: '---',
      priceWithIva: 0,
      idLeaseTech: 0,
    },
    insuranceSelected: {},
    purchaseValue: 0,
    extraPeriods: {}
  };

  destroyCar = new Subject<number>();

  constructor(
    private readonly dataService: DataService,
    private readonly catalogsService: CatalogsService,
    private readonly router: Router,
    private readonly stepService: StepService,
    private readonly dialog: MatDialog,
    @Inject(WINDOW) private readonly window: Window
  ) {
    this.dataService.getUpdatePreauthorize().subscribe((resp) => (this.isChanged = resp));
  }

  getInfoSummary(product: IProductDetail) {
    return new Promise((resolve) => {
      const { concept, period } = this.stepService.data.product;
      let { request, trasladoCost, extraPeriods } = product;

      let deadlineSelect: any = {
        concept: concept,
        ...product.period,
        trasladoCost,
        idQuoter: this.stepService.data.quoterId
      };

      let alldeadlines: any = [];
      alldeadlines[extraPeriods.concept] = extraPeriods;
      alldeadlines[extraPeriods.concept][`period${product.period?.period}`] = deadlineSelect;

      let dataQuoter: any = {
        protectionPlus: request?.protectionPlus,
        substituteCar: request?.substituteCar,
        km: request?.km,
        includeMaintenance: product.period?.deliveryCost?.maintenanceExpenses || request?.includeMaintenance ? true : false,
        ballon: request?.ballon,
        insuranceType: request?.insuranceType ? request.insuranceType as InsuranceTypeIDsEnum : InsuranceTypeIDsEnum.ANUAL_FINANCIADO_SIN_PAGO_ANUAL,
        includeGps: request?.includeGps || false,
        typeSustituteCar: request?.typeSustituteCar,
        includeAnnuities: request?.includeAnnuities || false,
        annuity: request?.annuity || 0,
        annuityPaymentMonth: request?.annuityPaymentMonth || 1,
      };

      let stateSelected: any = {
        stateName: request?.stateName,
      };

      if (request?.flowType === 'B') {
        dataQuoter = {
          ...dataQuoter,
          includeEnganche: request?.includeEnganche,
          engancheMax: request?.engancheMax,
          registrationState: request?.registrationState
        };

        let registrationState: string = request?.registrationState || '';
        this.summary.registrationState = registrationState;
        this.summary.car.idLeaseTech = request?.carId ?? 0;

      }


      this.summary.extraPeriods = alldeadlines ?? '';
      this.summary.deadlineSelect = deadlineSelect;
      this.summary.dataQuoter = dataQuoter;
      this.summary.stateSelected = stateSelected;
      this.summary.purchaseValue = deadlineSelect.purchaseValue || 0;

      try {
        this.summary.monthlyPayment = product.period!.monthlyPayment! + '';
        this.summary.initialPayment =
          product.period!.initialPayment! + product.trasladoCost! + '';
        this.summary.period = period;
        this.summary.concept = concept;
        this.summary.refund = this.templateSuffix !== '' ? this.summary.initialPayment : product.period!.initialPaymentDetail!.advancedRent! + '';

        const insuranceId = product.request?.insurance || product.request?.customInsurnace?.insurance;
        if (insuranceId) {
          const insuranceDesc = InsurancesDic.find((ele) => ele.value === insuranceId)!.key;
          this.summary.insuranceSelected = {
            insurance: {
              key: insuranceDesc,
            },
          };
          this.summary.insurance = insuranceDesc;
        } else {
          this.summary.insurance = '-----';
          this.summary.insuranceSelected = {};
        }

        const carObs = this.catalogsService.getQuoteCarById(
          product.request!.carId! + ''
        );
        const states = this.catalogsService.getStates();

        forkJoin([carObs, states]).subscribe(
          async ([carResp, stateResp]: [any, any]) => {
            const brand = carResp.data.hits.hits[0]._source.brand;
            const subBrand = carResp.data.hits.hits[0]._source.subBrand;
            const year = carResp.data.hits.hits[0]._source.year;
            const version = carResp.data.hits.hits[0]._source.version;
            const idLeaseTech = carResp.data.hits.hits[0]._source.idLeaseTech;

            const idJaito = carResp.data.hits.hits[0]._source.idJato;


            this.catalogsService.getImageById(idJaito).subscribe({
              next: (res: any) => this.summary.carImage = this.imgCarCard(res),
              error: (err: any) => this.summary.carImage = this.imgCarCard({ car: {} })
            })

            const state = stateResp.data.find(
              (ele: any) => ele.id === product.request!.stateId!
            );

            this.summary.carTitle = `${brand} ${subBrand}`;
            this.summary.carModel = `${version} ${year}`;
            this.summary.state = state.stateName;
            this.summary.priceWithIva = this.stepService.data.priceWithIva;

            this.summary.car = {
              brand,
              subBrand,
              version,
              year,
              priceWithIva: this.stepService.data.priceWithIva,
              idLeaseTech,
            };
            resolve(this.summary);
          }
        );
      } catch (error) {
        this.openAlert(
          null,
          'Ha ocurrido un error al obtener los datos de tu auto',
          'Entendido',
          null,
          true,
          Icons.error
        );
        this.router.navigate(['/home']);
      }
    })
  }

  openAlert(
    title: string | null,
    content: string,
    btnAction1: string | null,
    btnAction2: string | null,
    disableClose: boolean,
    icon: Icons
  ) {
    return this.dialog.open(ModalAlertComponent, {
      data: { icon, title, content, btnAction1, btnAction2 },
      disableClose,
    });
  }

  imgCarCard = (car: any) => {
    let not_found = './assets/img/auto_no_disponible.svg';
    if (car.imagenes) {
      let img_315;
      let img_45;
      let img_base;
      car.imagenes.forEach((item: string) => {
        if (item.includes('_315.')) {
          img_315 = item;
        }
        if (item.includes('_45.')) {
          img_45 = item;
        }
        if (!item.includes('_')) {
          img_base = item;
        }
      });
      return img_315 || img_45 || img_base || not_found;
    }

    if (car.poster) {
      return car.poster
    }
    return not_found;
  };

  openVideo(video: string, title: string) {
    let porcentaje = 0.6;
    if (this.window.innerHeight > this.window.innerWidth) {
      porcentaje = 0.3;
    }
    this.dialog.open(
      DialogVideoComponent,
      {
        id: 'dialog-video',
        panelClass: 'dialog-video',
        width: this.window.innerWidth.toString() + 'px',
        height: (this.window.innerHeight * porcentaje).toString() + 'px',
        data: {
          url: video,
          title: `Video info ${title}`,
          height: this.window.innerHeight * (porcentaje - 0.0702),
        }
      }
    )
  }

  getTitleSpecs(title: string) {
    if (title === 'transmision') return 'transmisión';
    if (title === 'suspension') return 'suspensión';

    return title;
  }
}



export interface ISummaryData {
  carTitle: string;
  carImage: string;
  state: string;
  priceWithIva: number;
  refund: number;
  concept: string;
  period: number | string;
  initialPayment: number;
  monthlyPayment: number;
  insurance: string;
  deadlineSelect: any;
  dataQuoter: any;
  stateSelected: any;
  car: any;
  insuranceSelected: any;
}
